module.exports = __webpack_public_path__ + "static/media/kaoku_guide.drawio.90fd0ecf.svg";